export enum ICommentsTypes {
  GET_TASK_COMMENTS_REQUEST = '@comments/GET_TASK_COMMENTS_REQUEST',
  GET_TASK_COMMENTS_SUCCESS = '@comments/GET_TASK_COMMENTS_SUCCESS',
  GET_TASK_COMMENTS_FAILURE = '@comments/GET_TASK_COMMENTS_FAILURE',
  COMMENT_TASK_COMMENTS_REQUEST = '@comments/COMMENT_TASK_COMMENTS_REQUEST',
  COMMENT_TASK_COMMENTS_SUCCESS = '@comments/COMMENT_TASK_COMMENTS_SUCCESS',
  COMMENT_TASK_COMMENTS_FAILURE = '@comments/COMMENT_TASK_COMMENTS_FAILURE',
  UPDATE_TASK_COMMENT_REQUEST = '@comments/UPDATE_TASK_COMMENT_REQUEST',
  UPDATE_TASK_COMMENT_SUCCESS = '@comments/UPDATE_TASK_COMMENT_SUCCESS',
  UPDATE_TASK_COMMENT_FAILURE = '@comments/UPDATE_TASK_COMMENT_FAILURE',
  DELETE_TASK_COMMENT_REQUEST = '@comments/DELETE_TASK_COMMENT_REQUEST',
  DELETE_TASK_COMMENT_SUCCESS = '@comments/DELETE_TASK_COMMENT_SUCCESS',
  DELETE_TASK_COMMENT_FAILURE = '@comments/DELETE_TASK_COMMENT_FAILURE',
}

export interface IGetCommentsRequestAction {
  type: typeof ICommentsTypes.GET_TASK_COMMENTS_REQUEST;
  payload: {
    processInstanceId: string | null;
  };
}
export interface IGetCommentsSuccessAction {
  type: typeof ICommentsTypes.GET_TASK_COMMENTS_SUCCESS;
  payload: {
    comments: Array<IComments>;
  };
}
export interface IGetCommentsFailureAction {
  type: typeof ICommentsTypes.GET_TASK_COMMENTS_FAILURE;
}

export interface ICommentTaskRequestAction {
  type: typeof ICommentsTypes.COMMENT_TASK_COMMENTS_REQUEST;
  payload: {
    processInstanceId: string | null;
    taskId: string | null;
    taskName: string | null;
    userId: string;
    userFirstName: string;
    userLastName: string;
    userAvatar: string;
    content: string;
  };
}
export interface ICommentTaskSuccessAction {
  type: typeof ICommentsTypes.COMMENT_TASK_COMMENTS_SUCCESS;
  payload: {
    comments: Array<IComments>;
  };
}
export interface ICommentTaskFailureAction {
  type: typeof ICommentsTypes.COMMENT_TASK_COMMENTS_FAILURE;
}

export interface IUpdateTaskCommentRequestAction {
  type: typeof ICommentsTypes.UPDATE_TASK_COMMENT_REQUEST;
  payload: {
    id: string;
    processInstanceId: string;
    taskId: string | null;
    content: string;
  };
}

export interface IUpdateTaskCommentSuccessAction {
  type: typeof ICommentsTypes.UPDATE_TASK_COMMENT_SUCCESS;
  payload: {
    comments: Array<IComments>;
  };
}
export interface IUpdateTaskCommentFailureAction {
  type: typeof ICommentsTypes.UPDATE_TASK_COMMENT_FAILURE;
}

export interface IDeleteTaskCommentRequestAction {
  type: typeof ICommentsTypes.DELETE_TASK_COMMENT_REQUEST;
  payload: {
    id: string;
    processInstanceId: string;
    taskId: string | null;
  };
}

export interface IDeleteTaskCommentSuccessAction {
  type: typeof ICommentsTypes.DELETE_TASK_COMMENT_SUCCESS;
  payload: {
    comments: Array<IComments>;
  };
}
export interface IDeleteTaskCommentFailureAction {
  type: typeof ICommentsTypes.DELETE_TASK_COMMENT_FAILURE;
}

export type ICommentsActionsType =
  | IGetCommentsRequestAction
  | IGetCommentsSuccessAction
  | IGetCommentsFailureAction
  | ICommentTaskRequestAction
  | ICommentTaskSuccessAction
  | ICommentTaskFailureAction
  | IUpdateTaskCommentRequestAction
  | IUpdateTaskCommentSuccessAction
  | IUpdateTaskCommentFailureAction
  | IDeleteTaskCommentRequestAction
  | IDeleteTaskCommentSuccessAction
  | IDeleteTaskCommentFailureAction;

export interface ICommentsState {
  loading: boolean;
  commentsList: IComments[] | undefined;
}

export enum StatusOption {
  REQUEST = 'request',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export interface IComments {
  id: string;
  processInstanceId: string;
  taskId: string;
  taskName: string;
  userId: string;
  userFirstName: string;
  userLastName: string;
  userAvatar: string;
  content: string;
  created_at: Date;
}

export interface ICommentParams {
  processInstanceId: string;
  taskId: string;
  taskName: string;
  userId: string;
  userFirstName: string | undefined;
  userLastName: string | undefined;
  userAvatar: string;
  content: string;
}

export interface IUpdateCommentParams {
  id: string;
  processInstanceId: string;
  taskId: string;
  content: string;
}

export interface IDeleteCommentParams {
  id: string;
  processInstanceId: string;
  taskId: string;
}
